<template>
    <div class="sessionTray">
        <notification-bar :text="notificationText" v-on:notification-click="onNotificationClicked"/>
        <div class="sessionList">
            <div v-for="(presentation, index) in presentationsGrouped" v-bind:key="index">
                <sessioncard  v-bind:presentation="presentation"></sessioncard>
            </div>
        </div>
        <div v-if="isEmpty" class="background-message">
            <div>
                <h1>{{$t('str.NoSessionsAvailable')}}</h1>
                <h2>{{$t('str.PleaseTryAgain')}}</h2>
                <div class='retry'>
                    <img src="../assets/icons/qr_code.png" />
                    <input v-model="retryUrl" class="input-retry" @keyup.enter="retry" />
                    <div v-if="isLoading" class="spinner-container"><spinner /></div>
                    <button v-on:click="retry" class="bt-retry" v-else="isRetrying">{{$t('str.Go')}}</button>
                </div>
            </div>
        </div>
        <spinner v-if="!isReady"/>
    </div>
</template>

<script>

import SessionCard from '@/components/SessionCard';
import Spinner from '@/components/Spinner';
import NotificationBar from '@/components/NotificationBar';
import {EventBus} from '../router/index';

export default {
    components: {
        sessioncard: SessionCard,
        spinner: Spinner,
        'notification-bar': NotificationBar
    },
    
    props: {
        presentations: {},
        isLoading: Boolean
    },

    data() {
        return {
            option: 'all',
            notificationText: undefined,
            callbackNotification: undefined,
            retryUrl: 'dialog.live/',
            isRetrying: true
        };
    },

    computed: {
        presentationsGrouped() {
            if (this.option === 'recents') {
                return []; // TODO: SDK call to implement?
            }

            return this.presentations;
        },

        isReady() {
            return !!this.presentationsGrouped && this.presentationsGrouped.constructor === Array;
        },

        isEmpty() {
            return this.isReady && !this.presentationsGrouped.length;
        }
    },

    watch: {
        presentations() {
            this.notificationText = undefined;
        }
    },

    mounted() {
        EventBus.$on('showBanner', (text, callback) => {
            this.notificationText = text;
            this.callbackNotification = callback;
        });
    },

    methods: {
        showAll() {
            this.option = 'all';
        },

        showRecents() {
            this.option = 'recents';
        },

        onNotificationClicked() {
            this.notificationText = undefined;
            
            if (this.callbackNotification) {
                this.callbackNotification();
            }
        },

        retry() {
            if (this.retryUrl.split('/').length > 1) {
                EventBus.$emit('reloadWithShortCodeUrl', this.retryUrl);
            }
        }
    }
};

</script>

<style lang="scss">
::-webkit-scrollbar {
  width: 5px;
}

::-webkit-scrollbar-track {
  border-radius: 0;
  box-shadow: inset 0 0 1px rgba(0, 0, 0, 0.0);
}

::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.0);
  border-radius: 0;
}

::-webkit-scrollbar-thumb:window-inactive {
  background: rgba(0, 0, 0, 0.0);
}

.sessionTray {
    width: 100%;
    color: #fff;
    box-sizing: inherit;
    z-index: 4000;
    position: absolute;
    background-color: #000000;
    top: 65px;
    bottom: 0;
    margin-bottom: 5px;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    padding-bottom: 60px;


    .sessionList {
        display: flex;
        flex-flow: row wrap;
        justify-content: center;
        align-items: flex-start;
        overflow: hidden;
    }

    .background-message {
        width: 100%;
        height: 100%;
        display: table;
        position: absolute;
        font-size: 0.9em;
        font-family: "Poppins", "Helvetica Neue", Helvetica, Arial, sans-serif;
        font-weight: normal;

        & > div {
            display: table-cell;
            text-align: center;
            width: 100%;
            vertical-align: middle;

            h1 {
                margin: 0 0 0.2em 0;
                font-weight: normal;
            }

            h2 {
                margin: 0 0 1em 0;
                font-weight: normal;
                font-size: 1.3em;
            }
        }

        .retry {
            // display: table;
            width: 100%;

            & > * {
                display: inline-block;
                vertical-align: middle;
            }

            img {
                width: 60px;
                height: 60px;
                margin-right: 10px;
            }

            input {
                width: 160px;
                padding: 6px;
                border: none;
                font-size: 1.3em;
                margin-right: 5px;
            }

            input:focus {
                outline: none;
            }

            button {
                padding: 6px 8px;
                font-size: 1.3em;
                border-radius: 0;
                background: #d4451d;
                color: white;
                border: none;
                cursor: pointer;
            }

            .spinner-container {
                width: 20px;
                height: 20px;

                .spinner {
                    width: 20px;
                    height: 20px;
                    margin-top: 0;
                }
            }
        }
    }
}

</style>



// WEBPACK FOOTER //
// SessionsTray.vue?76e4dfbd